import(/* webpackMode: "eager" */ "/home/shehin/test/karetrip-blog/app/[slug]/error.tsx");
